export const userAgreementTerms = [
  { label: 'terms.iHaveCarefullyRead', value: false, name: 'terms_understand' },
  { label: 'terms.asProvided', value: false, name: 'terms_compensation' },
  { label: 'terms.iHaveFullRight', value: false, name: 'terms_authority' },
];

export const competitionAgreementTerms = [
  { name: 'competition_guidelines', label: 'competitionsGuidelinesModal.agreeToPaticipate', value: false },
];

export const TeamAgreementTerms = [{ name: 'terms_understand', value: false, label: 'team.terms.1' }];

export const genericAgreementTerms = [{ label: 'terms.generic', value: false, name: 'terms_understand' }];

export const TeamConsultantAgreementTerms = [{ name: 'terms_understand', value: false, label: 'teams.consultant.terms' }];
export const TeamNonConsultantAgreementTerms = [{ name: 'terms_understand', value: false, label: 'teams.non.consultant.terms' }];
